import React, { Component } from 'react';

import NavigationService from './services/Navigation.service';
import NavigationView from './views/views/NavigationView';


type AppProps = {
}

type AppState = {
  navigationService: NavigationService
}

export default class App extends Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);
    this.state = {
      navigationService: new NavigationService()
    };
  }

  public render() {
    return (
      <NavigationView navigationService={this.state.navigationService}></NavigationView>
    );
  }
}